import { render, staticRenderFns } from "./BidsList.vue?vue&type=template&id=fafe66aa&scoped=true"
import script from "./BidsList.vue?vue&type=script&lang=js"
export * from "./BidsList.vue?vue&type=script&lang=js"
import style0 from "./BidsList.vue?vue&type=style&index=0&id=fafe66aa&prod&lang=scss&scoped=true"
import style1 from "./BidsList.vue?vue&type=style&index=1&id=fafe66aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fafe66aa",
  null
  
)

export default component.exports